import { IMenuItem } from "./navigation.model";

export let dietitianMenu: IMenuItem[] = [
  {
    name: "Consultation",
    type: "link",
    tooltip: "Consultation",
    module: ["consultation"],
    state: "dietitian/info/list",
    sub: [
      {
        name: "Consultation",
        type: "link",
        module: ["consultation"],
        state: "dietitian/info/view",
      },
      {
        name: "Consultation",
        type: "link",
        module: ["consultation"],
        state: "dietitian/info/attend",
      },
    ],
  },
];

export let pysioMenu: IMenuItem[] = [
  {
    name: "Consultation",
    type: "link",
    tooltip: "Consultation",
    module: ["consultation"],
    state: "physiotherapist/info/list",
    sub: [
      {
        name: "Consultation",
        type: "link",
        module: ["consultation"],
        state: "physiotherapist/info/view",
      },
      {
        name: "Consultation",
        type: "link",
        module: ["consultation"],
        state: "physiotherapist/info/attend",
      },
    ],
  },
];

export let gymMenu: IMenuItem[] = [
  {
    name: "DASHBOARD",
    type: "link",
    tooltip: "Dashboard",
    module: ["dashboard"],
    state: "dashboard",
  },
  {
    name: "Members",
    type: "link",
    module: ["member", "feedback"],
    state: "members",
    sub: [
      { name: "Members", module: ["feedback"], type: "link", state: "feedback" },
    ]
  },
  {
    name: "Employees",
    type: "link",
    module: ["employee", "leave_request_trainer_portal"],
    state: "employees",
    sub: [
      { name: "Employees", module: ["leave_request_trainer_portal"], type: "link", state: "leave-request" },
    ]
  },
  {
    name: "Personal Trainer",
    type: "link",
    tooltip: "Personal Trainer Portal",
    module: ["dashboard"], // Using dashboard permission for now to ensure visibility
    state: "personal-trainer",
  },
  {
    name: "Store",
    type: "link",
    tooltip: "Store",
    module: ["dashboard"],
    state: "pos",
  },
  {
    name: "Finance",
    type: "link",
    tooltip: "Finance",
    module: ["employee", "expenses", "group", "ledger", "sundry_parties", "opening_balance", "closing_balance"],
    state: "finance",
  },
  {
    name: "Reports",
    type: "link",
    tooltip: "Reports",
    module: ["body_measurement_report", "upcoming_renewals", "active_member_report", "enquiry_report", "weight_measurement_report", 'complaint_report', 'member_attendance', 'member_admission_report', 'manual_attandanace_report', 'payment_transaction_report', 'employee_report', "balance_sheet_report", "employee_attendance", "group_balance_sheet"],
    state: "reports",
  },
  {
    name: "Fees",
    type: "link",
    tooltip: "Fees",
    module: ["fees"],
    state: "fees",
    sub: [
      { name: "Fees", module: ["fees"], state: "fees/fees-payment" },
      { name: "Fees", module: ["fees"], state: "fees/member-search" },
      { name: "Fees", module: ["fees"], state: "fees/paynow" },
      { name: "Fees", module: ["fees"], state: "fees/billview" },
    ],
  },
  {
    name: "Enquiry",
    type: "link",
    tooltip: "Enquiry",
    module: ["Enquiry"],
    state: "enquiry",
  },
  {
    name: "Equipment",
    type: "link",
    tooltip: "Equipment",
    module: ["equipment"],
    state: "equipment",
  },
  {
    name: "Lockers",
    type: "link",
    tooltip: "Lockers",
    module: ["locker"],
    state: "locker",
    sub: [
      {
        name: "Locker",
        type: "link",
        module: ["locker"],
        state: "locker/assign",
      },
      {
        name: "Locker",
        type: "link",
        module: ["locker"],
        state: "locker/available",
      },
    ],
  },
  {
    name: "More",
    type: "dropDown",
    module: [
      "offers", "quotes", "steam_attendance", "whatsapp_message",
      "workout", "meal_plan", "locker",
      "user", "role", "role_permission", "employee_type", "employee_attendance_setting",
      "member_attendance_setting", "trainer_type", "food", "workout_category", "membership",
      "exercise", "strech", "warm_up", "locker_config", "consultation_fees", "hub_settings",
      "mealplan_name", "trainer_attendance", "trainer_membership", "heart_rate", "weight_receiver", "heartrate_receiver"
    ],
    state: "",
    sub: [


      {
        name: "Consultation",
        type: "dropDown",
        module: ["physiotherapist", "dietition", "consultation_fees"],
        state: "",
        sub: [
          {
            name: "Physiotherapist",
            module: ["physiotherapist"],
            state: "consultation/physiotherapist-list",
            sub: [
              {
                name: "Physiotherapist",
                module: ["physiotherapist"],
                state: "consultation/Physiotherapist-list",
              },
            ],
          },
          {
            name: "Dietitian",
            module: ["dietition"],
            state: "consultation/dietitian-list",
            sub: [
              {
                name: "Dietitian",
                module: ["dietition"],
                state: "consultation/dietitian-list",
              },
            ],
          },
          {
            name: "Consultation Fees",
            module: ["consultation_fees"],
            state: "consultation-fees-update",
          },
        ],
      },
      {
        name: "Message",
        type: "dropDown",
        module: ["offers", "quotes", "steam_attendance", "whatsapp_message"],
        state: "",
        sub: [
          {
            name: "Offers",
            module: ["offers"],
            state: "message/offers",
            sub: [
              {
                name: "Offers",
                module: ["offers"],
                state: "message/offers",
              },
              {
                name: "Offers",
                module: ["offers"],
                state: "message/offers-message"
              }
            ],
          },
          {
            name: "Quotes",
            module: ["quotes"],
            state: "message/quotes",
            sub: [
              {
                name: "Quotes",
                module: ["quotes"],
                state: "message/quotes",
              },
            ],
          },
          {
            name: "Steam Attendance",
            module: ["steam_attendance"],
            state: "message/steam-attendance",
            sub: [
              {
                name: "Steam Attendance",
                module: ["steam_attendance"],
                state: "message/steam-attendance",
              },
            ],
          },
          {
            name: "Whatsapp Message",
            module: ["whatsapp_message"],
            state: "message/whatsapp-message",
            sub: [
              {
                name: "Whatsapp Message",
                module: ["whatsapp_message"],
                state: "message/whatsapp-message",
              },
            ],
          },
        ],
      },
      {
        name: "Fitness",
        type: "dropDown",
        module: ["workout", "meal_plan", "exercise", "strech", "warm_up"],
        state: "",
        sub: [
          {
            name: "Workout",
            type: "link",
            module: ["workout"],
            state: "workout",
            sub: [
              { name: "Workout", module: ["workout"], state: "workout/create" },
              { name: "Workout", module: ["workout"], state: "workout/edit" },
              { name: "Workout", module: ["workout"], state: "workout/view" },
            ],
          },
          {
            name: "Meal Plan",
            type: "link",
            module: ["meal_plan"],
            state: "meal-plan",
            sub: [
              { name: "Meal Plan", module: ["meal_plan"], state: "diet-plan/create" },
              { name: "Meal Plan", module: ["meal_plan"], state: "diet-plan/edit" },
              { name: "Meal Plan", module: ["meal_plan"], state: "diet-plan/view" },
            ],
          },
          {
            name: "Exercise",
            module: ["exercise"],
            state: "exercise",
            sub: [
              { name: "Exercise", module: ["exercise"], state: "exercise/create" },
              { name: "Exercise", module: ["exercise"], state: "exercise/edit" },
              { name: "Exercise", module: ["exercise"], state: "exercise/view" },
            ],
          },
          {
            name: "Stretches",
            module: ["strech"],
            state: "stretch",
            sub: [
              { name: "Stretches", module: ["stretch"], state: "stretch/create" },
              { name: "Stretches", module: ["stretch"], state: "stretch/edit" },
              { name: "Stretches", module: ["stretch"], state: "stretch/view" },
            ],
          },
          {
            name: "Warm Up",
            module: ["warm_up"],
            state: "warmup",
            sub: [
              { name: "Warm Up", module: ["warm_up"], state: "warm-up/create" },
              { name: "Warm Up", module: ["warm_up"], state: "warm-up/edit" },
              { name: "Warm Up", module: ["warm_up"], state: "warm-up/view" },
            ],
          },
        ],
      },






      // {
      //   name: "Other Services",
      //   type: "link",
      //   module: ["Enquiry"],
      //   state: "other-services",
      // },

      {
        name: "Configuration",
        type: "dropDown",
        module: [
          "user",
          "role",
          "role_permission",
          "employee_type",
          "employee_attendance_setting",
          "member_attendance_setting",
          // "threshold_setting",
          "trainer_type",
          "food",
          "workout_category",
          "membership",
          "equipment",
          "exercise",
          "strech",
          "warm_up",
          "locker_config",
          "consultation_fees",
          "hub_settings",
          "mealplan_name",
          "trainer_attendance",
          'trainer_membership',
          "heart_rate",
          "weight_receiver",
          "heartrate_receiver"
        ],
        state: "",
        sub: [
          {
            name: "Hub",
            type: "dropDown",
            state: "",
            sub: [
              {
                name: "Hub",
                module: ["hub_settings"],
                state: "hub_settings",
              },
              {
                name: "Weight Receiver",
                module: ["weight_receiver"],
                state: "weight-receiver",
              },
              {
                name: "Heart Rate Receiver",
                module: ["heartrate_receiver"],
                state: "heartrate-receiver",
              },
            ]
          },







          // { name: "Locker", module: ["locker_config"], state: "locker-update" },
          {
            name: "Administration",
            type: "dropDown",
            module: ["user", "role", "role_permission"],
            state: "",
            sub: [
              { name: "Roles", module: ["role"], state: "role" },
              { name: "Users", module: ["user"], state: "users" },
              {
                name: "Roles & Permissions",
                module: ["role_permission"],
                state: "role-permission",
              },
            ],
          },
          {
            name: "Face Display",
            type: "link",
            module: ["hub_settings"],
            state: "face-display",
          },
          {
            name: "360° Tour Settings",
            type: "link",
            module: ["hub_settings"],
            state: "three-sixty-view",
          },
          { name: "Finger Print", module: ["finger-print"], state: "" },
        ],
      }
    ]
  }
];

export let trainerMenu: IMenuItem[] = [


  {
    name: "Members",
    type: "link",
    tooltip: "Members",
    module: ["member"],
    state: "members",
    sub: [
      {
        name: "Member",
        type: "link",
        module: ["member"],
        state: "members/view",
      },
      {
        name: "Member",
        type: "link",
        module: ["member"],
        state: "members/edit",
      },
      {
        name: "Member",
        type: "link",
        module: ["member"],
        state: "members/create",
      },
    ],
  },
  {
    name: "Consultation",
    type: "dropDown",
    module: ["physiotherapist", "dietition"],
    state: "",
    sub: [
      {
        name: "Physiotherapist",
        module: ["physiotherapist"],
        state: "consultation/physiotherapist-list",
        sub: [
          {
            name: "Physiotherapist",
            module: ["physiotherapist"],
            state: "consultation/Physiotherapist-list",
          },
        ],
      },
      {
        name: "Dietitian",
        module: ["dietition"],
        state: "consultation/dietitian-list",
        sub: [
          {
            name: "Dietitian",
            module: ["dietition"],
            state: "consultation/dietitian-list",
          },
        ],
      },
    ],
  },
  // {
  //   name: "Leave Request",
  //   module: ["leave_request_trainer_portal"],
  //   state: "leave-request",
  // },
  {
    name: "Leave Request",
    type: "link",
    module: ["leave_request_trainer_portal"],
    state: "leave-request",
    sub: [],
  },
  {
    name: "Fitness",
    type: "dropDown",
    tooltip: "Fitness",
    module: ["workout", "meal_plan", "exercise", "strech", "warm_up"],
    state: "",
    sub: [
      {
        name: "Workout",
        type: "link",
        module: ["workout"],
        state: "workout",
        sub: [
          { name: "Workout", module: ["workout"], state: "workout/create" },
          { name: "Workout", module: ["workout"], state: "workout/edit" },
          { name: "Workout", module: ["workout"], state: "workout/view" },
        ],
      },
      {
        name: "Meal Plan",
        type: "link",
        module: ["meal_plan"],
        state: "meal-plan",
        sub: [
          { name: "Meal Plan", module: ["meal_plan"], state: "diet-plan/create" },
          { name: "Meal Plan", module: ["meal_plan"], state: "diet-plan/edit" },
          { name: "Meal Plan", module: ["meal_plan"], state: "diet-plan/view" },
        ],
      },
      {
        name: "Exercise",
        module: ["exercise"],
        state: "exercise",
        sub: [
          { name: "Exercise", module: ["exercise"], state: "exercise/create" },
          { name: "Exercise", module: ["exercise"], state: "exercise/edit" },
          { name: "Exercise", module: ["exercise"], state: "exercise/view" },
        ],
      },
      {
        name: "Stretches",
        module: ["strech"],
        state: "stretch",
        sub: [
          { name: "Stretches", module: ["stretch"], state: "stretch/create" },
          { name: "Stretches", module: ["stretch"], state: "stretch/edit" },
          { name: "Stretches", module: ["stretch"], state: "stretch/view" },
        ],
      },
      {
        name: "Warm Up",
        module: ["warm_up"],
        state: "warmup",
        sub: [
          { name: "Warm Up", module: ["warm_up"], state: "warm-up/create" },
          { name: "Warm Up", module: ["warm_up"], state: "warm-up/edit" },
          { name: "Warm Up", module: ["warm_up"], state: "warm-up/view" },
        ],
      },
    ],
  },

  {
    name: "Reports",
    type: "link",
    tooltip: "Reports",
    module: ["body_measurement_report", "weight_measurement_report"],
    state: "reports",
  },
  {
    name: "Configuration",
    type: "dropDown",
    tooltip: "Configuration",
    module: [
      "food",
      "workout_category",
      "membership",
      "equipment",
      "exercise",
      "strech",
      "warm_up",
      "mealplan_name",
    ],
    state: "",
    sub: [


      { name: "Equipment", module: ["equipment"], state: "equipment" },

    ],
  },
];
